"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationChannelSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.NotificationChannelSchema = zod_1.z.object({
    channel: zod_1.z.nativeEnum(__1.ENotificationChannel),
    payloadVersion: __1.ShortStringSchema,
    payload: zod_1.z.record(zod_1.z.unknown()).optional(),
    channelAdditionalData: zod_1.z.record(zod_1.z.unknown()).optional(),
});
//# sourceMappingURL=common.js.map